<template>
  <div>
    <h1 class="mb-7 font-roboto text-[26px] font-semibold leading-8">
      {{ pageTitle }}
    </h1>
    <WikiCatalogFilters
      class=""
      @change-category="(val) => updateQueryParam('category', val)"
      @change-period="(val) => updateQueryParam('period', val)"
      @change-sort="(val) => updateQueryParam('sort', val)"
      @submit-search="(val) => updateQueryParam('search', val)"
    />

    <!-- <div
      v-if="wikisData.length"
      class="grid w-full grid-cols-1 gap-5 md:grid-cols-2 2xl:grid-cols-3"
    >
      <div v-for="wiki in wikisData" :key="wiki.id" class="relative">
        <WikiCard :data="wiki" disable-label />
      </div>
    </div> -->

    <div v-if="wikisData.length" class="mt-6 grid grid-cols-1 md:grid-cols-3">
      <NuxtLink
        v-for="wiki in wikisData"
        :key="wiki.id"
        :to="`/encyclopedia/${wiki.slug}`"
        class="group flex flex-col border-b border-[#F9F0F1] p-5 transition-colors hover:bg-new-gray-light/10"
      >
        <div class="flex items-center justify-between gap-2">
          <div
            class="text-gray-800 cursor-pointer text-[14px] font-bold uppercase tracking-wide transition-colors group-hover:text-specialprojectsection"
          >
            {{ wiki.title }}
          </div>
        </div>
      </NuxtLink>
    </div>

    <div
      v-else
      class="mx-auto mt-16 grid max-w-[594px] justify-center gap-5 text-center font-roboto text-new-card--title-black"
    >
      <div
        class="text-[26px] font-semibold leading-8 text-new-card--title-black"
      >
        По вашему запросу результатов не найдено
      </div>
      <div class="text-[18px] leading-6">
        Попробуйте изменить настройки фильтров, чтобы увидеть интересующие вас
        материалы
      </div>
    </div>

    <BaseThePagination :entity="wikis" />
  </div>
</template>

<script setup>
import api from '~~/services/api/api';

const router = useRouter();
const route = useRoute();

const updateQueryParam = (key, value) => {
  const nextQuery = { ...route.query };
  if (value === '') {
    delete nextQuery[key];
  } else {
    nextQuery[key] = value;
  }
  if (key !== 'page' && nextQuery.page) {
    delete nextQuery.page;
  }
  if (key === 'period') {
    delete nextQuery.from;
  }
  router.push({ path: route.path, query: nextQuery });
};

const { wikis } = useWikis({
  per_page: 30,
  filters: computed(() => ({
    category: route.query.category || null,
    period: route.query.period || null,
    search: route.query.search || '',
    sort: route.query.sort || 'last',
  })),
  page: computed(() => Number(route.query.page) || 1),
});

const wikisData = computed(() => wikis.data.value?.data || []);

const { data: periods } = useAsyncData('wiki-periods', async () => {
  const res = await api.wikis.getWikisPeriods();
  return res?.data?.data ?? null;
});

const { data: rubrics } = useAsyncData('wiki-rubrics', async () => {
  const res = await api.wikis.getWikisRubrics();
  return res?.data ?? null;
});

const selectedRubricTitle = computed(
  () =>
    (rubrics.value?.data ?? []).find(
      (item) => item.slug === route.query.category,
    )?.title ?? '',
);

const selectedPeriodTitle = computed(
  () =>
    (periods.value ?? []).find((item) => item.slug === route.query.period)
      ?.title ?? '',
);

const pageTitle = computed(() =>
  route.query.from === 'periods' && selectedPeriodTitle.value
    ? `Каталог — ${selectedPeriodTitle.value}`
    : 'Каталог',
);

const selectedFilters = computed(() =>
  [selectedRubricTitle.value, selectedPeriodTitle.value].filter(Boolean),
);

const canonicalUrl = computed(() => {
  const query = new URLSearchParams();

  ['category', 'period', 'page'].forEach((key) => {
    if (route.query[key]) query.set(key, route.query[key]);
  });

  const search = query.toString();

  return `${useHostApp()}${route.path}${search ? `?${search}` : ''}`;
});

useHead(() => ({
  title: `${
    selectedFilters.value.length ? `${selectedFilters.value.join(', ')} | ` : ''
  }Каталог Российской исторической энциклопедии | История РФ`,
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: selectedFilters.value.length
        ? `Статьи Российской исторической энциклопедии по теме «${selectedFilters.value.join(
            ', ',
          )}». Проверенные материалы о ключевых вехах российской и мировой истории. Российское военно-историческое общество.`
        : 'Каталог Российской исторической энциклопедии: статьи по рубрикам и историческим периодам. Проверенные материалы о ключевых вехах российской и мировой истории. Российское военно-историческое общество.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
